import * as Sentry from '@sentry/react';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';
import React from 'react';

export const initSentry = () => {

   if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      console.log('Sentry disabled for localhost');
      return;
   }

   let environment = 'production';

   if (window.location.hostname.includes('dev-') ||
      window.location.hostname.includes('development-')) {
      environment = 'development';
   }
   else if (window.location.hostname.includes('staging') ||
      window.location.origin.includes('staging')) {
      environment = 'staging';
   }

   Sentry.init({
      dsn: 'https://366b6bfe0a96c5c1910e54b37d12fd38@o4508304860643328.ingest.us.sentry.io/4508304908288000',
      environment: environment,
      sendDefaultPii: false,
      defaultIntegrations: false,
      integrations: [
         Sentry.browserTracingIntegration(),
         Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
            networkDetailAllowUrls: [
               '/api/v1/*',
            ]
         }),
         Sentry.browserProfilingIntegration(),
         Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
         }),
         Sentry.setTag
      ],
      tracesSampleRate: 0.2,
      profilesSampleRate: 0.1,
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event) {
         if (event.request && event.request.headers) {
            delete event.request.headers['Authorization'];
            delete event.request.headers['Cookie'];
         }

         if (event.contexts && event.contexts.userData) {
            delete event.contexts?.userData?.email;
            delete event.contexts?.userData?.fullName;
         }

         return event;
      },
      beforeBreadcrumb(breadcrumb) {
         if (
            breadcrumb.category === 'xhr' ||
            breadcrumb.category === 'fetch'
         ) {
            const url = breadcrumb.data?.url || '';
            if (
               url.includes('.css') ||
               url.includes('.js') ||
               url.includes('.png') ||
               url.includes('.jpg') ||
               url.includes('.jpeg') ||
               url.includes('.svg') ||
               url.includes('.woff') ||
               url.includes('.woff2') ||
               url.includes('/assets/') ||
               url.includes('/static/')
            ) {
               return null;
            }
         }

         return breadcrumb;
      },

      beforeSendTransaction(event) {
         if (event.spans) {
            event.spans = event.spans.filter(span => {
               const url = span.data?.url;
               if (typeof url === 'string') {
                  return !(
                     url.includes('.css') ||
                     url.includes('.js') ||
                     url.includes('.png') ||
                     url.includes('.svg') ||
                     url.includes('/assets/') ||
                     url.includes('/static/')
                  );
               }
               return true;
            });
         }

         return event;
      }
   });
};